import { Security } from '../../proto/generated/security'
import { getSecurityKey } from '../../util/security'
import store from '../../store'

/** Display price (decimal) for screener context menu / alerts from live LTP. */
export function getScreenerContextMenuPrice(security: Security): string {
    const key = getSecurityKey(security.exchange, security.code)
    const snap = store.getState().securityStore.snapshots[key]
    if (!snap?.lastTradedPrice) return ''
    return (snap.lastTradedPrice / (security.priceMultiplier ?? 100)).toFixed(2)
}
